import QueryBoundaries from '@/shared/components/QueryBoundaries';
import useHydratePendingOfferPolling from './useHydratePendingOfferPolling';

const HydratePendingOfferPollingCaller = () => {
  useHydratePendingOfferPolling();
  return null;
};

export const HydratePendingOfferPolling = () => {
  return (
    <QueryBoundaries>
      <HydratePendingOfferPollingCaller />
    </QueryBoundaries>
  );
};

export default HydratePendingOfferPolling;
